// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__s5mFA","insightsList":"newBusinessInsightsMenu_insightsList__q1BPq","active":"newBusinessInsightsMenu_active__jMjA9"};